// extracted by mini-css-extract-plugin
export var beforeTitle = "Press-module--beforeTitle--3O6iv";
export var item = "Press-module--item--1UJIw";
export var info = "Press-module--info--1UTrg";
export var quote = "Press-module--quote--3v4GL";
export var heading = "Press-module--heading--sUaWz";
export var row = "Press-module--row--1Divv";